<template>
    <div class="gallery">
        <div class="stage">
            <div class="h-100 w-100 position-relative" style="cursor:pointer;"
                 @mouseover="mouseOver = true"
                 @mouseleave="mouseOver = false">
                <div class="image-overlay" v-if="mouseOver">
                    <b-button-group style="position: absolute; bottom:10px; right: 10px">
                        <b-button size="sm" variant="primary" @click="downloadImage(currentImage, 'jpeg')"><i
                                class="fa-download fal fa"></i>.jpeg
                        </b-button>
                        <b-button size="sm" variant="primary" @click="downloadImage(currentImage, 'png')"><i
                                class="fa-download fal fa"></i>.png
                        </b-button>
                        <b-button size="sm" variant="primary" @click="showImage(currentImage.src)"><i
                                class="fa-expand fal fa p-0"></i>
                        </b-button>
                    </b-button-group>
                </div>
                <b-img style="position: absolute; left:0; right: 0"
                       v-if="currentImage"
                       :key="currentIndex" :src="currentImage.src"></b-img>

            </div>

        </div>
        <div v-if="currentImage && currentImage.label" class="text-right"
             :key="currentIndex">
            <small>{{currentImage.label}}</small>
        </div>

        <pb-carousel v-if="images && images.length > 0">
            <pb-carousel-item class="my-3 card-deck category-card-deck"
                              @click.native="goTo(index)" :key="index" v-for="(img, index) in images">
                <div class="card slider-card border-0 m-0 p-0 cursor-pointer">
                    <div class="card-body p-0">
                        <div v-bind:class="[{ active: index === Number(currentIndex) }, 'thumbnail']">
                            <img :src="img.src" alt="Card image cap"/>
                        </div>

                    </div>
                </div>
            </pb-carousel-item>
        </pb-carousel>

        <b-modal hide-footer hide-header size="xl" id="single" ref="single">
            <b-img class="single-img" v-if="selectedImage" :src="selectedImage"></b-img>
        </b-modal>
    </div>
</template>

<script>
    import * as axios from "axios";

    export default {
        name: 'ImageGallery',
        props: ['images'],
        data() {
            return {
                selectedIndex: 0,
                selectedImage: null,
                downloadFormat: 'png',
                mouseOver: false,
                downloadFormatOptions: [
                    {text: '.png', value: 'png'},
                    {text: '.jpeg', value: 'jpeg'}
                ]
            }
        },
        methods: {
            showImage(selectedImage) {
                this.selectedImage = selectedImage;
                this.$refs['single'].show();
            },
            goTo(index) {
                this.selectedIndex = index;
            },
            downloadImage(image, format) {
                axios({
                    url: this.articleImageResource(image.name, 1000, format),
                    method: 'GET',
                    responseType: 'blob',
                }).then((response) => {
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement('a');

                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', image.name.substr(0, image.name.lastIndexOf(".")) + '.' + format);
                    document.body.appendChild(fileLink);
                    fileLink.click();
                });
            }
        },
        computed: {
            currentIndex: function () {
                return this.selectedIndex >= 0 ? this.selectedIndex : this.images.findIndex(img => img.isDefault);
            },
            currentImage: function () {
                return this.images[this.currentIndex];
            }
        },
        watch: {
            images: function () {
                this.selectedIndex = undefined;
            }
        }
    }

</script>
<style lang="scss" scoped>

    @import "~bootstrap/scss/functions";
    @import "~bootstrap/scss/variables";
    @import "~bootstrap/scss/mixins/_breakpoints";

    .single-img {
        object-fit: cover;
        width: 100%;
        height: 100%;
    }

    .gallery {
        .stage {
            text-align: center;
            margin: auto;
            height: 565px;
            overflow: hidden;

            @include media-breakpoint-down(md) {
                padding: 20px;
                height: 380px;
            }

            img {
                width: 100%;
                height: 100%;
                object-fit: contain;
                object-position: 50% 50%;
            }
        }


        .thumbnail {
            cursor: pointer;
            height: 70px;
            width: 70px;
            display: inline-block;
            opacity: 0.4;
            transition: opacity .5s ease-out;
            -moz-transition: opacity .5s ease-out;
            -webkit-transition: opacity .5s ease-out;
            -o-transition: opacity .5s ease-out;

            &:hover, &:hover *, &.active, &.active * {
                opacity: 1;
            }

            img {
                object-fit: scale-down;
                width: 100%;
                height: 100%;
            }
        }

        .image-overlay {
            width: 100%;
            height: 100%;
            background-color: rgba(241, 241, 241, 0.5);
            position: absolute;
            z-index: 10
        }
    }
</style>